import React from 'react';

const APP_COLOURS = {
  Quda:    { bg: '#e0f9f9', text: '#0e7490', border: '#a5f3fc' },
  HaloPay: { bg: '#fef3c7', text: '#b45309', border: '#fde68a' },
  HaloText:{ bg: '#ede9fe', text: '#6d28d9', border: '#ddd6fe' },
  DocLink: { bg: '#f3e8ff', text: '#7e22ce', border: '#e9d5ff' },
  MediDrop:{ bg: '#ffedd5', text: '#c2410c', border: '#fed7aa' },
  Zephyr:  { bg: '#ede9fe', text: '#4c1d95', border: '#c4b5fd' },
  Webbit:  { bg: '#dcfce7', text: '#15803d', border: '#bbf7d0' },
  HaloHire:  { bg: '#ffe4e6', text: '#be123c', border: '#fecdd3' },
  HaloExpire:{ bg: '#e0e7ff', text: '#3730a3', border: '#c7d2fe' },
};

const AppBadge = ({ app, size = 'sm' }) => {
  const colours = APP_COLOURS[app] || { bg: '#f3f4f6', text: '#374151', border: '#e5e7eb' };
  return (
    <span
      className={`inline-flex items-center rounded-full font-semibold border ${size === 'xs' ? 'text-[10px] px-1.5 py-0' : 'text-xs px-2 py-0.5'}`}
      style={{ backgroundColor: colours.bg, color: colours.text, borderColor: colours.border }}
    >
      {app}
    </span>
  );
};

export default AppBadge;
